/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ErpArticleConnectionType {
  None = 0,
  SeExport = 1,
  SeImport = 2,
  NoExport = 3,
  NoImport = 4,
  ExtraCaseRows = 5,
  ExtraCaseTime = 6,
  Eur1 = 7,
  RegistrationCard = 8,
  Delivery = 9,
  CustomsFee = 10,
  OutlayImportVAT = 11,
  HandlingFee = 12,
  T2L = 13,
  OtherInvoicing = 14,
}
